import Link from "next/link"
import Image from "components/Image"
import storyblokImageLoader from "utilities/storyblokImageLoader"

export default function TeamMemberCard({ image, first_name, last_name, job_title, slug }) {
  return (
    <article className="h-full flex flex-col">
      <Image
        loader={image?.filename && image?.filename !== "" ? storyblokImageLoader : undefined}
        src={image?.filename && image.filename !== "" ? image.filename : "/assets/team-member-placeholder.jpg"}
        alt={image.alt ? image.alt : `${first_name} ${last_name}`}
        width={300}
        height={250}
        className="w-full aspect-[3/2.5] object-cover bg-highlight-tint"
      />
      <div className="border-b-0.5 border-x-0.5 px-2.5 sm:px-7 py-6 border-grey-cool flex flex-col h-full">
        <Link href={slug} className="text-center">
          <h3 className="team-member-card-name text-m1 sm:text-m2 text-primary font-primary font-semibold hover:underline relative block w-full before:bg-[url('public/assets/curly-bracket.svg')] before:content-[''] lg:before:hidden lg:hover:before:block lg:before:bg-contain lg:before:bg-no-repeat before:absolute before:w-3 before:h-12 before:-left-1.5 sm:before:-left-3 before:-top-2 after:bg-[url('public/assets/curly-bracket.svg')] after:bg-contain after:bg-no-repeat after:content-[''] lg:after:hidden lg:hover:after:block after:absolute after:rotate-180 after:w-3 after:h-12 after:-top-2 after:-right-1.5 sm:after:-right-3 transition-all duration-300">
            {first_name} {last_name}
          </h3>
        </Link>
        <h4 className="text-center text-base text-primary font-primary">{job_title}</h4>
      </div>
    </article>
  )
}
